<template>
  <div :inert="guideActive || null" class="bfms-portal bfms-vendor" :class="{ 'bfms-auth-page': !showMobileNavigation }">
  <sidenav
    :custom_class="this.$store.state.mcolor"
    :class="[
      this.$store.state.isTransparent,
      this.$store.state.isRTL ? 'fixed-end' : 'fixed-start',
    ]"
    v-if="this.$store.state.showSidenav"
  />
  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
    :style="this.$store.state.isRTL ? 'overflow-x: hidden' : ''"
  >
    <!-- nav -->
    <navbar
      :class="[navClasses]"
      :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : ''"
      :minNav="navbarMinimize"
      v-if="this.$store.state.showNavbar"
    />
    <div class="bfms-page-content"><router-view /></div>
    <!-- <app-footer v-show="this.$store.state.showFooter" /> -->
    <configurator
      :toggle="toggleConfigurator"
      :class="[
        this.$store.state.showConfig ? 'show' : '',
        this.$store.state.hideConfigButton ? 'd-none' : '',
      ]"
    />
  </main>
  <worker-guide v-if="showMobileNavigation" @active-change="guideActive = $event" />
  <mobile-navigation v-if="showMobileNavigation" portal="vendor" />
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
const WorkerGuide = defineAsyncComponent(() => import(/* webpackChunkName: 'worker-guide' */ './components/Guide/WorkerGuide.vue'));
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import MobileNavigation from "./components/MobileNavigation.vue";
import "./assets/css/mobile.css";
// import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";
export default {
  name: "App",
  data: () => ({ guideActive: false }),
  components: {
    Sidenav,
    Configurator,
    Navbar,
    MobileNavigation,
    WorkerGuide,
    // AppFooter,
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
  },
  computed: {
    showMobileNavigation() {
      return this.$store.state.showSidenav && !['/sign-in', '/sign-up', '/forgot_password'].includes(this.$route.path);
    },
    navClasses() {
      return {
        "position-sticky blur shadow-blur mt-4 left-auto top-1 z-index-sticky": this
          .$store.state.isNavFixed,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4 mt-4": !this.$store.state.isAbsolute,
      };
    },
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
};
</script>
